var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_27509_70486)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.3496 5.83325V28.3666",
    stroke: "#69B0E4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.6163 17.0999H49.083",
    stroke: "#69B0E4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.633 103.075V136.817",
    stroke: "#FECC53",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.5 119.95H163.767",
    stroke: "#FECC53",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.1914 194.642C87.4997 193.333 75.2247 190.6 62.458 186.467C26.408 174.808 0.0830389 156.4 3.65804 145.342C4.97471 141.275 10.158 138.767 17.983 137.808",
    stroke: "#FECC53",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.741 168C130.683 175.175 135.916 182.233 134.191 187.567C133.008 191.217 128.716 193.608 122.191 194.758",
    stroke: "#FECC53",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.616 38.3334C148.658 25.6834 163.816 20.3251 176.466 26.3667C189.116 32.4084 194.475 47.5668 188.433 60.2168C182.391 72.8668 167.233 78.2251 154.583 72.1834",
    stroke: "#FECC53",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.6245 93.2332C62.087 93.2332 69.7579 85.5624 69.7579 76.0999C69.7579 66.6374 62.087 58.9666 52.6245 58.9666C43.1621 58.9666 35.4912 66.6374 35.4912 76.0999C35.4912 85.5624 43.1621 93.2332 52.6245 93.2332Z",
    stroke: "#FECC53",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.8997 135.833C105.357 135.833 110.591 130.599 110.591 124.142C110.591 117.684 105.357 112.45 98.8997 112.45C92.4425 112.45 87.208 117.684 87.208 124.142C87.208 130.599 92.4425 135.833 98.8997 135.833Z",
    stroke: "#2A518C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.233 128.133C115.616 132.658 113.15 136.475 109.691 138.925",
    stroke: "#FECC53",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.05 53.4583L106.758 53.15C100.233 52.2666 94.2912 56.9916 93.6828 63.55L91.2162 90.3083C90.6495 96.475 95.0412 102 101.175 102.833C107.316 103.667 113.016 99.5166 114.116 93.4166L118.875 66.9666C120.041 60.4916 115.575 54.3416 109.05 53.4583Z",
    stroke: "#2A518C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.717 104.975C117.417 103.308 119.417 100.542 120.017 97.1834L124.775 70.7334",
    stroke: "#FECC53",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.767 113.05L131.017 30.3833C124.692 14.425 102.95 12.3583 93.7249 26.8333L73.2666 58.9583",
    stroke: "#69B0E4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.9084 100.358L30.8501 125.575C22.0834 139.342 31.6668 157.417 47.9834 157.892L151.158 160.867C166.258 161.3 176.883 146.15 171.317 132.1L168.983 126.208",
    stroke: "#69B0E4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.358 170.592L159.108 171.275C170.592 171.608 179.492 162.917 180.642 152.558",
    stroke: "#69B0E4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_27509_70486"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 195.833,
    height: 190.592,
    fill: "white",
    transform: "translate(2.5 5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.5c72e0d0195c60414491717077422a11.svg";
export { ForwardRef as ReactComponent };